<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">

        <a-form-model-item
          prop="category"
          label="测评类">
          <a-input placeholder="请输入测评类" v-model="model.category" />
        </a-form-model-item>

        <a-form-model-item
          prop="name"
          label="名称">
          <a-input placeholder="请输入名称" v-model="model.name" />
        </a-form-model-item>
        <a-form-model-item
          prop="appraise"
          label="评价">
          <a-textarea :rows="2" placeholder="请输入评价" v-model="model.appraise" />
        </a-form-model-item>
        <a-form-model-item
          prop="suggest"
          label="建议">
          <a-textarea :rows="2" placeholder="请输入建议" v-model="model.suggest" />
        </a-form-model-item>
        <a-form-model-item
          prop="appraise2"
          help="针对“社会支持”底部显示的明细评价。"
          label="评价2">
          <a-textarea :rows="2" placeholder="请输入评价2" v-model="model.appraise2" />
        </a-form-model-item>
        <a-form-model-item
          prop="suggest2"
          label="建议2">
          <a-textarea :rows="2" placeholder="请输入建议2" v-model="model.suggest2" />
        </a-form-model-item>
        <a-form-model-item
            prop="sortNum"
          label="排序">
          <a-input-number v-model="model.sortNum" :min="0" :precision="0" style="width: 100%" placeholder="请输入排序" />
        </a-form-model-item>
        <a-form-model-item
            prop="configJson"
            :help="help"
          label="计算配置">
          <a-textarea :rows="2"  placeholder="请输入计算配置" v-model="model.configJson" />
        </a-form-model-item>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import baseRules from '@/constants/baseRules'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: "ProjectResultConfigModal",
    components: { ATextarea },
    data () {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        title:"操作",
        visible: false,
        help:'采用数组json格式，参考文档的 “A1+B1+C1: 你拥有来自家庭、朋友和周围人良好的社会支持” ，示例1：[["A1","B1","C1"]]；示例2：[["SB3","SW1","SC1"],["SB3","SW2","SC1"],["SB3","SW3","SC1"]]；示例3：[["C3"]]。',
        model: {},
        rules:{
          category:[baseRules.required],
          name:[baseRules.required],
          sortNum:[baseRules.required],
          configJson:[baseRules.required],
          appraise:[baseRules.required],
          suggest:[baseRules.required],
        },
        confirmLoading: false,

        url: {
          add: "/project/projectResultConfig/add",
          edit: "/project/projectResultConfig/edit",
        },
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({
          projectId:this.projectId,
          configJson:'[[""]]',
          sortNum:0
        });
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            const s = JSON.parse("123")
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.close();
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>

</style>